import { Auth } from 'aws-amplify';

let inFlightSignOut: Promise<void> | null = null;

// One sign-out per page. Amplify clears the tokens before it redirects to Cognito's logout
// endpoint, so anything that starts a sign-in in between (a 401 handler, a route guard) would
// cancel that redirect while the hosted UI's own session is still alive. isSigningOut() stays
// true until the redirect unloads the page.
export function signOut(): Promise<void> {
  inFlightSignOut ??= (async () => {
    sessionStorage.clear();
    try {
      await Auth.signOut();
    } catch (err) {
      // Amplify rejects with "Signout timeout fail" if the hosted-UI redirect hasn't torn
      // the page down within its hardcoded 3s. The session is already cleared and the
      // redirect still happens, so there is nothing to recover from here.
      console.warn('Sign out did not complete cleanly:', err);
    }
  })();
  return inFlightSignOut;
}

export function isSigningOut(): boolean {
  return inFlightSignOut !== null;
}

// Tests only: a real page never comes back from a sign-out.
export function resetSignOut(): void {
  inFlightSignOut = null;
}
